module.exports = __webpack_public_path__ + "static/media/glasses-icon.c9a72598.svg";